module.exports = __webpack_public_path__ + "static/media/bg-coworking.3ea8bc21.jpg";